



import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'


import getLocation from "@/components/getLocation";

import leLayer from "@/components/leLayer";

import detailPop from "@/components/detailPop";

import scenicPop from "@/components/scenicPop";


export default {
directives: {
TransferDom,
},

components: {

Tab,
TabItem,
LoadMore,
XImg,
Popup,
TransferDom,
getLocation,
leLayer,
Swiper,
SwiperItem,
detailPop,
scenicPop,
},
data() {

return {

tollitImgDefault: "", // 卫生间按钮
locationImgDefault: "", // 定位按钮
locationImgActive: "", // 定位按钮选中
searchImgDefault: "", // 搜索按钮
viewImgDefault: "", // 手绘按钮
viewImgActive: "", // 手绘按钮选中

shopPopup: false, //顶部景区提示pop
scenicName: null,
isPopUp: false, //底部进入景区提示组件是否展开收起
xImgDftSrc: "./static/img/timg.gif",
xImgNoImg: "./static/img/no_img.jpg",

mapObj: null, //地图实例
hid: this.$route.query.hid ? this.$route.query.hid : 15847,
leLayer: null, //瓦片实例
isLelayerShow: true, //瓦片展示
mapMaxZoom: 18, //地图最大层级
mapMinZoom: 5, //地图最小层级
scenicZoom: 7, //当前景区展示层级
scenicLat: 30.244132, //当前景区中心点lat
scenicLng: 120.147476, //当前景区中心点lng
scenicBound: [], //景区电子围栏范围
geocoder: null, //地理编码实例
geolocation: null, //定位组件
isLocation: false, //是否展示当前定位了
locationMarker: null, //当前定位marker点
curProvinceMarkerArr: [], //省级时 聚合点集合 或者 风情小镇
curMapMarkers: [], //当前地图上展示的marker点 从curProvinceMarkerArr对应层级中取对应数组




adCode: -1, //高德的adCode 浙江省3300 用于是否要切换景区时做判断
citycode: null, //高德地理位置查询得到的城市code
cityPolygons: [], //行政区域边界线
areaData: null, //当前景区的所有数据
type_code: -1, //当前滑块中选中的点位分类的code type_code=32为乡村民宿 要做特殊处理
is_aggregate: 0, //地图上是否聚合展示点位信息 0否 1是
area_id: -1, // 当前滑块中选中的市或区的id
tag_id: -1, // 当前滑块中选中标签id

curMenuListIndex: 0, //点位分类的选中下标

curTagListIndex: 0, //当前选中标签的下标
areaSortResult: [], //当前景区筛选后的结果集





isMoved: false,
flags: false,
screenH: document.documentElement.clientHeight, //屏幕高度
sliderTop: null,
sliderBasicHeight: 90, //初始bottom值
mapHeight: "100%",
position: { x: 0, y: 0 },
nx: "",
ny: "",
dx: "",
dy: "",
xPum: "",
yPum: "",

loadMsg: "加载中...",
isContentTop: true, //子滚动区滚到顶部
isContentBottom: false, //子滚动区滚到底部部




isDetailPopShow: false, //名宿等详情弹窗
details: {
imgList: [],
title: "",
address: "",
des: "",
mobile: "",
lat: "",
lng: "",
is_guide: false,
id: "",
},



isScenicPopShow: false,
scenicPopData: {},
};
},

computed: {
sliderHeight: function () {

return this.screenH - parseInt(this.sliderTop.split("px")[0]) + "px";
},
},

watch: {

shopPopup(val) {
if (val) {
setTimeout(() => {
this.shopPopup = false;
}, 2000);
}
},
},

methods: {

getAreaData(adCode, hid, code) {
let that = this;
that.get({
url:

that.GLOBAL.BASE_URL + "/api/v1/index!getComponentsAndScenics.action",
params: {
adCode: adCode, //adcode
hid: hid, //景区id
type_code: code,
lat: sessionStorage.getItem("lat"),
lng: sessionStorage.getItem("lng"),



},
isShowLoading: false,
success: function (data) {
console.log(data.data);
that.areaData = data.data.data;

that.scenicLng = data.data.data.hotspot.longitude_gcj;
that.scenicLat = data.data.data.hotspot.latitude_gcj;
that.scenicZoom = data.data.data.hotspot.rank;
that.adCode = data.data.data.hotspot.adcode;
that.hid = data.data.data.hotspot.id;
document.title = data.data.data.hotspot.name;


that.scenicName = data.data.data.hotspot.name;
that.shopPopup = true;

that.area_id = -1;
that.tag_id = -1;
if (that.mapObj != null) {



} else {

that.getMap();
}


for (let i in data.data.data.menuList) {
if (code) {

if (data.data.data.menuList[i].com_code == code) {
that.curMenuListIndex = i; 
that.type_code = data.data.data.menuList[i].com_code;
that.areaSortResult = data.data.data.menuList[i].hotspotList;
that.loadMsg = "全部加载完毕";
that.is_aggregate = data.data.data.menuList[i].is_aggregate;
if (that.is_aggregate == 1) {

that.setAggregateMarker(data.data.data.menuList[i].areaList);
} else {

that.setUnaggregateMarker(
data.data.data.menuList[i].hotspotList,
data.data.data.menuList[i].com_code,
data.data.data.menuList[i].point_icon,
data.data.data.menuList[i].point_picth_icon
);
}
break;
}
} else {


if (data.data.data.menuList[i].visible == 2) {
that.curMenuListIndex = i; 
that.type_code = data.data.data.menuList[i].com_code;
that.areaSortResult = data.data.data.menuList[i].hotspotList;





that.loadMsg = "全部加载完毕";
that.is_aggregate = data.data.data.menuList[i].is_aggregate;
if (that.is_aggregate == 1) {

that.setAggregateMarker(data.data.data.menuList[i].areaList);
} else {

that.setUnaggregateMarker(
data.data.data.menuList[i].hotspotList,
data.data.data.menuList[i].com_code,
data.data.data.menuList[i].point_icon,
data.data.data.menuList[i].point_picth_icon
);
}
break;
}
}
}

for (let i in data.data.data.iconList) {
if (data.data.data.iconList[i].com_id == 6) {

that.tollitImgDefault =
that.GLOBAL.DOMAIN_URL + data.data.data.iconList[i].icon;
} else if (data.data.data.iconList[i].com_id == 7) {

that.locationImgDefault =
that.GLOBAL.DOMAIN_URL + data.data.data.iconList[i].icon;
that.locationImgActive =
that.GLOBAL.DOMAIN_URL + data.data.data.iconList[i].picth_icon;
} else if (data.data.data.iconList[i].com_id == 8) {

that.searchImgDefault =
that.GLOBAL.DOMAIN_URL + data.data.data.iconList[i].icon;
} else if (data.data.data.iconList[i].com_id == 9) {

that.viewImgDefault =
that.GLOBAL.DOMAIN_URL + data.data.data.iconList[i].icon;
that.viewImgActive =
that.GLOBAL.DOMAIN_URL + data.data.data.iconList[i].picth_icon;
}
}


},
});
},


getMap() {
let that = this;

that.mapObj = new AMap.Map("container", {
view: new AMap.View2D({


center: new AMap.LngLat(that.scenicLng, that.scenicLat),
zoom: that.scenicZoom, //设置地图缩放级别
rotation: 0, //设置地图旋转角度
}),
resizeEnable: true,
zooms: [that.mapMinZoom, that.mapMaxZoom],
features: ["bg", "road", "building"],
lang: "zh_cn", //设置地图语言类型，默认：中文简体
});
that.isLocation = true; 

that.leLayer = new AMap.TileLayer({


tileUrl: "https://tiles.worldmaipu.com/global/all2/[z]/[x]_[y].png",
zIndex: 2,
});
that.leLayer.setMap(that.mapObj);


AMap.event.addListener(that.mapObj, "zoomend", function () {
let lnglat = [that.mapObj.getCenter().lng, that.mapObj.getCenter().lat];
let zoom = that.mapObj.getZoom();
if (zoom > 13) {
that.leLayer.setTileUrl(


"https://tiles.worldmaipu.com/all/[z]/[x]_[y].png"
);
}






else {
that.leLayer.setTileUrl(

"https://tiles.worldmaipu.com/global/all2/[z]/[x]_[y].png"
);
}

that.geocoder.getAddress(lnglat, function (status, result) {

if (status === "complete" && result.info === "OK") {


let cityCode = result.regeocode.addressComponent.adcode.substring(
0,
4
);

if (
result.regeocode.addressComponent.adcode.substring(0, 2) == "33"
) {
if (zoom < 9) {
} else if (zoom < 19) {

console.log("市级及以下");
if (cityCode == that.adCode) {

console.log("没有切换市级 切换不同层级的点");
that.mapChangeMarkers();
} else {
}
}
}
}
});
});

AMap.event.addListener(that.mapObj, "moveend", function () {
console.log("move......................");




that.mapMoveEnd();
});






AMap.event.addListener(that.mapObj, "click", function () {
console.log("点击地图");
that.mapHeight = that.screenH - that.sliderBasicHeight + "px"; 
that.sliderTop = that.screenH - that.sliderBasicHeight + "px"; 
that.isPopUp = false;
});


that.mapObj.plugin(["AMap.ToolBar"], function () {
that.mapObj.addControl(
new AMap.ToolBar({
position: "RB",

liteStyle: true,
offset: new AMap.Pixel(10, 180),
})
);
});

that.mapObj.plugin("AMap.Geocoder", function () {
that.geocoder = new AMap.Geocoder({

city: "浙江省",
extensions: "base",
});


});
},


mapMoveEnd() {
let that = this;
let lnglat = [this.mapObj.getCenter().lng, this.mapObj.getCenter().lat];
let zoom = this.mapObj.getZoom();
console.log("当前层级：" + zoom);
this.geocoder.getAddress(lnglat, function (status, result) {

if (status === "complete" && result.info === "OK") {

console.log(result);





let cityCode = result.regeocode.addressComponent.adcode.substring(
0,
4
);
console.log(cityCode + "..." + that.adCode);

if (
result.regeocode.addressComponent.adcode.substring(0, 2) == "33"
) {
console.log("在浙江省内");

console.log("市级adcode：" + cityCode);
if (zoom < 9) {
that.mapObj.remove(that.cityPolygons);
that.citycode = null;

console.log("省级5-8");
if (that.adCode == 3300) {
return;
} else {
that.hid = 15847;
that.adCode = 3300;
that.getAreaData(that.adCode, that.hid);
}
} else if (zoom < 19) {
if (that.citycode == result.regeocode.addressComponent.citycode) {
} else {
console.log("画区域边界");
that.citycode = result.regeocode.addressComponent.citycode;
AMap.plugin("AMap.DistrictSearch", function () {

let district = new AMap.DistrictSearch({

extensions: "all",

level: "city",
});

district.search(that.citycode, function (status, result) {

let bounds = result.districtList[0].boundaries;
that.mapObj.remove(that.cityPolygons);
that.cityPolygons = [];
if (bounds) {
for (let i = 0, l = bounds.length; i < l; i++) {

let polygon = new AMap.Polygon({
map: that.mapObj,
strokeWeight: 2,
path: bounds[i],
fillOpacity: 0,

strokeColor: "#48636e",
});
that.cityPolygons.push(polygon);
}


}
});
});
}


console.log("市级及以下");
if (cityCode == that.adCode) {

console.log("没有切换市级");
} else {
that.adCode = cityCode;
console.log("切换市级");

that.getAreaData(that.adCode, null, that.type_code);
}
}
} else {
that.mapObj.remove(that.cityPolygons);
that.citycode = null;
console.log("不在浙江省内");
console.log("市级adcode：" + cityCode);
if (zoom < 9) {

console.log("省级5-8");
if (that.adCode == 3300) {
return;
} else {
that.hid = 15847;
that.adCode = 3300;
that.getAreaData(that.adCode, that.hid);
}
}
}
}
});
},



down() {
console.log("down..................");
this.flags = true;
let touch;
if (event.touches) {
touch = event.touches[0];
} else {
touch = event;
}
this.position.x = touch.clientX;
this.position.y = touch.clientY;
this.dx = moveDiv.offsetLeft;
this.dy = moveDiv.offsetTop;
},

move(e) {
console.log("move..................");
this.isMoved = true;
let sliderResult = document.getElementById("slider_result");
let sliderTags = document.getElementById("sliderTags");

if (this.flags) {
let touch;
if (event.touches) {
touch = event.touches[0];
} else {
touch = event;
}



if (sliderResult.querySelector("." + e.target.className)) {

console.log("在滚动区域滑");
if (this.isContentTop == true) {


if (touch.clientY - this.position.y > 0) {

} else {


return;
}
} else if (this.isContentBottom == true) {
if (touch.clientY - this.position.y < 0) {
} else {
return;
}
} else {
return;
}
} else if (sliderTags.querySelector("." + e.target.className)) {
} else {
e.preventDefault();


}
this.nx = touch.clientX - this.position.x;
this.ny = touch.clientY - this.position.y;

this.xPum = this.dx + this.nx;
this.yPum = this.dy + this.ny;




if (Math.abs(this.ny) > Math.abs(this.nx)) {

e.preventDefault();
if (this.yPum < 0) {
this.sliderTop = 0 + "px";
} else {
this.sliderTop = this.yPum + "px"; 

}
} else {

}





document.addEventListener(
"touchmove",
function (event) {



event.stopPropagation(); 
},
false
);
}
},

end() {
console.log("end..................");


if (!this.isMoved) {
return;
}

this.flags = false;
this.isMoved = false;

let upPercent = (1 - this.yPum / this.screenH).toFixed(2);


if (upPercent < 0.25) {
console.log("0---0.25");
this.mapHeight = this.screenH - this.sliderBasicHeight + "px"; 
this.sliderTop = this.screenH - this.sliderBasicHeight + "px"; 
this.isPopUp = false;
} else if (upPercent < 0.75) {

console.log("0.25---0.75");
this.mapHeight = this.screenH / 2 + "px"; 
this.sliderTop = this.screenH / 2 + "px"; 
this.isPopUp = true;
} else if (upPercent < 2) {
this.mapHeight = 0 + "px"; 
this.sliderTop = 0 + "px"; 
this.isPopUp = true;
}
},



sortResultScroll(e) {
e.stopPropagation();

let scrollTop = document.getElementById("slider_result").scrollTop;
let clientHeight = document.getElementById("slider_result").clientHeight;
let scrollHeight = document.getElementById("slider_result").scrollHeight;
if (clientHeight == scrollHeight) {

this.isContentTop = true;
this.isContentBottom = true;
} else {

if (scrollTop == 0) {
console.log("滚动区在顶部");
this.isContentTop = true;
} else if (scrollTop + clientHeight == scrollHeight) {
console.log("滚动区在底部");
this.isContentBottom = true;

} else {
this.isContentTop = false;
this.isContentBottom = false;
}
}
},

changeMenu(i, code, type, url) {
console.log("切换menu");

if (type == 3) {
window.location.href = url;
} else {

if (code != this.type_code) {
console.log("changeMenu");
this.type_code = code;
this.curMenuListIndex = i;
this.curTagListIndex = 0;
this.is_aggregate =
this.areaData.menuList[this.curMenuListIndex].is_aggregate;
this.tag_id = -1;
this.area_id = -1;

this.changeSort(true);
}










if (this.isPopUp) {
return;
} else {
this.isPopUp == true;
this.sliderTop = "50%";
this.mapHeight = this.screenH / 2 + "px"; 
}
}
},

changeCity(i, id, lat, lng) {
console.log("切换区域");
console.log(i + "---" + id);
if (this.area_id == id) {
return;
} else {

if (lat != 0 && lng != 0) {
this.mapObj.setCenter([lng, lat]);
}
this.area_id = id;
console.log(this.area_id);

if (this.is_aggregate == 1) {
this.changeSort(false);
} else {
this.changeSort(true);
}
}
},

changeTag(i, id) {
console.log("切换tag");

if (id == this.tag_id) {
return;
} else {

this.curTagListIndex = i;
this.tag_id = id;

this.changeSort(true);
}
},

getAreaSortResult(needChangeMaker) {
let that = this;
this.loadMsg = "加载中...";
that.get({
url: that.GLOBAL.BASE_URL + "/api/v1/index!getDeatilDatas.action",
params: {

hid: that.hid, //景区id
type_code: that.type_code, //父区域滑块总分类code
area_id: that.area_id, //子区域id
tag_id: that.tag_id, //子区域中左侧筛选id


is_aggregate: that.is_aggregate, //是否聚合展示
lat: sessionStorage.getItem("lat"),
lng: sessionStorage.getItem("lng"),
},
isShowLoading: false,
success: function (data) {
console.log(data.data);

that.areaSortResult = data.data.data.detailList.hotspotList;





if (that.areaSortResult == null || that.areaSortResult.length == 0) {
that.loadMsg = "暂无数据";
} else {
that.loadMsg = "全部加载完成";
}
if (needChangeMaker) {
if (that.is_aggregate == 1) {

that.setAggregateMarker(data.data.data.detailList.areaList);
} else {

that.setUnaggregateMarker(
data.data.data.detailList.hotspotList,
data.data.data.detailList.com_code,
data.data.data.detailList.point_icon,
data.data.data.detailList.point_picth_icon
);
}
}
},
});
},

changeSort(needChangeMaker) {



this.areaSortResult = [];
this.getAreaSortResult(needChangeMaker);
},

setAggregateMarker(pointArr) {
let that = this;


this.mapObj.remove(this.curMapMarkers);
this.curMapMarkers = [];
for (let i in pointArr) {
let marker = new AMap.Marker({
map: this.mapObj,
content:
"<div class='province-poi'><div class='aggregate-bg'></div><span class='aggregate-name'><span>" +
pointArr[i].name +
"</span><i>" +
pointArr[i].counts +
"</i>" +
"</span></div>",
position: new AMap.LngLat(
pointArr[i].longitude_gcj,
pointArr[i].latitude_gcj
),

offset: new AMap.Pixel(-10, -32), //中心点



extData: {
hotspot_id: pointArr[i].hotspot_id,
},
});
AMap.event.addListener(marker, "click", function (e) {
let position = e.target.getPosition();
let extData = e.target.getExtData();
this.setTop(true);
console.log(extData);
that.hid = extData.hotspot_id;

that.mapObj.setZoomAndCenter(9, position);



});
this.mapObj.remove(marker);

this.curMapMarkers.push(marker);
}
this.mapObj.add(this.curMapMarkers);
},

setUnaggregateMarker(pointArr, code, defaultBg, acitveBg) {
let that = this;


that.resetCurProvinceMarkerArr();

for (let i in pointArr) {

let level = pointArr[i].level;
let marker = new AMap.Marker({

content:
"<div class='province-poi'><img src='" +
that.GLOBAL.DOMAIN_URL +
defaultBg +
"' class='ua_poi' id='ua_marker" +
i +
"'><span class='ua_poi_name'>" +
pointArr[i].name +
"</span></div>",
position: new AMap.LngLat(
pointArr[i].longitude_gcj,
pointArr[i].latitude_gcj
),
offset: new AMap.Pixel(-16, -36),

extData: {
hotspot_id: pointArr[i].id,
com_code: code,
default_bg: defaultBg,
active_bg: acitveBg,
id_index: i,
poiData: pointArr[i],
level: level,
},
});
for (let z = 0; z < that.curProvinceMarkerArr.length; z++) {


let startZoom = level - that.mapMinZoom;
if (startZoom <= z) {
that.curProvinceMarkerArr[z].push(marker);
}
}
AMap.event.addListener(marker, "click", function (e) {
let position = e.target.getPosition();
let extData = e.target.getExtData();
this.setTop(true);
console.log(extData);
that.mapObj.setCenter(position);

if (extData.poiData.com_code == 20) {

that.get({
url: that.GLOBAL.BASE_URL + "/api/v1/index!getHotelDetail.action",
params: {
id: extData.hotspot_id, //景区id
},
isShowLoading: false,
success: function (data) {
console.log(data.data);


that.details.is_guide = extData.poiData.is_guide;
that.details.id = extData.hotspot_id;
that.details.imgList = data.data.data.imgs;
that.details.title = data.data.data.homeStays.homestay_name;
that.details.address = data.data.data.homeStays.address;
that.details.des = data.data.data.homeStays.characters;
that.details.mobile = data.data.data.homeStays.mobile;
that.details.lat = data.data.data.homeStays.latitude;
that.details.lng = data.data.data.homeStays.longitude;
that.isDetailPopShow = true;
},
});
} else {

let data = {
address: extData.poiData.address,
audio: extData.poiData.audio,
com_code: extData.poiData.com_code,
id: extData.hotspot_id,
is_guide: extData.poiData.is_guide,
latitude_gcj: extData.poiData.latitude_gcj,
longitude_gcj: extData.poiData.longitude_gcj,
name: extData.poiData.name,
thumb_img: extData.poiData.thumb_img,
};
that.scenicPopData = data;
that.isScenicPopShow = true;
}
});


}


that.mapChangeMarkers();
},

resetCurProvinceMarkerArr() {
this.curProvinceMarkerArr = [];
for (let i = this.mapMinZoom; i < this.mapMaxZoom + 1; i++) {

this.curProvinceMarkerArr.push([]);
}
},

mapChangeMarkers() {
console.log("市级切换层级 的点位");
let zoom = this.mapObj.getZoom();
this.mapObj.remove(this.curMapMarkers);
this.curMapMarkers = [];
this.curMapMarkers = this.curProvinceMarkerArr[zoom - this.mapMinZoom];
console.log("加载第" + zoom + "级的点");
this.mapObj.add(this.curMapMarkers);
},
jumpTo(obj) {
let that = this;
if (obj.com_code == 20) {

that.get({
url: that.GLOBAL.BASE_URL + "/api/v1/index!getHotelDetail.action",
params: {
id: obj.id, //景区id
},
isShowLoading: false,
success: function (data) {
console.log(data.data);
let details = {};

details.is_guide = obj.is_guide;
details.id = obj.id;
details.imgList = data.data.data.imgs;
details.title = data.data.data.homeStays.homestay_name;
details.address = data.data.data.homeStays.address;
details.des = data.data.data.homeStays.characters;
details.mobile = data.data.data.homeStays.mobile;
details.lat = data.data.data.homeStays.latitude;
details.lng = data.data.data.homeStays.longitude;

that.details = details;
that.isDetailPopShow = true;
},
});
} else {

let data = obj;
console.log(obj);
that.scenicPopData = data;
that.isScenicPopShow = true;
}
},

changeDetailPop(val) {
this.isDetailPopShow = val;
if (val == false) {
this.details = {
imgList: [],
title: "",
address: "",
des: "",
mobile: "",
lat: "",
lng: "",
is_guide: false,
id: "",
}; //清空详情组件的details props
}
},

changeScenicPop(val) {
this.isScenicPopShow = val;

},

getScenicDetailFromScenicPop(val) {
let that = this;

that.get({
url: that.GLOBAL.BASE_URL + "/api/v1/map_view!detail.action",
params: { hid: val.id },
isShowLoading: false,
success: function (data) {
console.log(data.data.data);
let details = {};
details.is_guide = val.is_guide;
details.id = data.data.data.hotspot.id;
details.imgList = [];
for (let i in data.data.data.imgList) {
details.imgList.push(
that.GLOBAL.DOMAIN_URL + data.data.data.imgList[i].midImg
);
}

details.title = data.data.data.hotspot.name;
details.address = data.data.data.hotspot.address;
details.des = data.data.data.hotspot.description;
details.mobile = "";
details.lat = data.data.data.hotspot.latitudeGCJ + "";
details.lng = data.data.data.hotspot.longitudeGCJ + "";
if (data.data.data.hotspot.audio != null) {
details.audio =
that.GLOBAL.DOMAIN_URL +
data.data.data.hotspot.audio.split(".")[0] +
".mp3";
}

that.details = details;
},
});
this.isScenicPopShow = false;
this.isDetailPopShow = true;
},



























































},

created() {
this.getAreaData(null, this.hid);
},

mounted() {
console.log(this.$route.query);


this.sliderTop = this.screenH - this.sliderBasicHeight + "px";
this.mapHeight = this.screenH - this.sliderBasicHeight + "px";



















































},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {








}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};



// WEBPACK FOOTER //
// ./src/pages/Index.vue